var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component",attrs:{"sidebar":_vm.sidebar,"header":_vm.header}},[_c('router-view')],1),_c('HelpDeskWidget')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }